import { extractData } from '@/models';
import type { RequestCreateTransaction } from '@/types';

import client from '../../assets/js/services/api';

export default {
    createTransaction(payload: RequestCreateTransaction) {
        return client
            .post('/api/transaction/create/', payload)
            .then(extractData);
    },
};
